import { useAuth } from '@/stores/auth'
import { storeToRefs } from 'pinia'
import wretch from 'wretch'
import { trackApiError } from '@/helpers/integrations/datadog'

export const api = () => {
  const auth = storeToRefs(useAuth())

  let url = import.meta.env.VITE_POKER_SERVER_DOMAIN || undefined
  if (url && !url.startsWith('http')) {
    url = `${window.location.protocol}//${url}`
  }

  return wretch(url)
    .auth(`Bearer ${auth.token.value}`)
    .catcher(401, (error) => {
      trackApiError(url, error, { status: 401 })

      // Signal specifically that auth token is invalid (not general error)
      const authStore = useAuth()
      authStore.markAuthAsInvalid()

      const authError = new Error('Authentication failed')
      authError.name = 'AuthenticationError'
      authError.message = `Authentication failed: ${error.message || 'Unknown error'}`

      throw authError
    })
    .catcher(403, (error) => {
      trackApiError(url, error, { status: 403 })

      // Signal that access is forbidden (user needs to login with proper permissions)
      const authStore = useAuth()
      authStore.markAsForbidden()

      const forbiddenError = new Error('Access forbidden')
      forbiddenError.name = 'ForbiddenError'
      forbiddenError.message = `Access forbidden: ${error.message || 'Insufficient permissions'}`

      throw forbiddenError
    })
    .catcher(404, (error) => {
      trackApiError(url, error, { status: 404 })
      throw error
    })
    .catcher(500, (error) => {
      trackApiError(url, error, { status: 500 })
      throw error
    })
    .catcher(502, (error) => {
      trackApiError(url, error, { status: 502 })
      throw error
    })
    .catcher(503, (error) => {
      trackApiError(url, error, { status: 503 })
      throw error
    })
    .catcher(504, (error) => {
      trackApiError(url, error, { status: 504 })
      throw error
    })
    .catcher(0, (error) => {
      trackApiError(url, error, { status: 0, type: 'network_error' })
      throw error
    })
}
